// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:31:11.915Z
// Property: The Bellamy (ID: 5706772312489984)
// Collections: 14 amenities, 7 floorplans (live), 26 photos, 80 POIs, 4 reviews, 4 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5706772312489984",
  "property_external_id": "5056163",
  "property_zillow_url": "https://www.zillow.com/apartments/charlotte-nc/the-bellamy/5XhwD3/",
  "property_apartments_url": "https://www.apartments.com/the-bellamy-charlotte-nc/c2gxrwd",
  "property_google_business_url": "https://www.google.com/maps/place/The+Bellamy/data=!4m2!3m1!1s0x0:0x342da3944cc58e7c?sa=X&ved=2ahUKEwi924Ofy7ySAxXEUUEAHVceISYQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "9835663923",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-bellamy",
  "property_name": "The Bellamy",
  "property_website_url": "https://www.liveatthebellamy.com/",
  "property_domain": "https://www.liveatthebellamy.com/",
  "property_address": "10015 Parthenon Ct",
  "property_full_address": "10015 Parthenon Ct, Charlotte, NC 28262",
  "property_address_1": "10015 Parthenon Ct",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28262-1298",
  "property_address_zip": "28262",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "University City North",
  "property_address_latitude": "35.3267957",
  "property_address_longitude": "-80.7431768",
  "property_email": "bellamy@alapts.com",
  "property_phone": "(704) 971-4100",
  "property_call_tracking_phone": "980-575-5436",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Room to settle into University City.</strong> The Bellamy pairs spacious one-, two-, and three-bedroom apartments with polished everyday finishes and easy community comforts—ready to see what feels like home?</p>",
  "property_long_description": "<p><strong>Room to settle into University City.</strong> At The Bellamy, you get spacious one-, two-, and three-bedroom apartments with the everyday upgrades that make home feel polished: granite or quartz countertops, stainless steel appliances, built-in microwaves, walk-in closets, washer/dryer, ceiling fans, and select vaulted ceilings. Beyond your door, the <a href=\"/amenities\">amenity mix</a> keeps things easy with a pool, fitness center, tennis court, pet play area, outdoor grilling, package lockers, car care center, and 24/7 online resident services.</p><p>Set in University City North, you’re close to the area’s biggest anchors without losing a quieter residential feel. UNC Charlotte, the JW Clay/UNC Charlotte LYNX Blue Line station, University Research Park, and Concord-Padgett Regional Airport are all nearby, while The Shoppes at University Place brings lakefront dining, errands, and seasonal farmers market energy into your routine. For fresh air and weekend plans, explore Reedy Creek Nature Center, UNC Charlotte Botanical Gardens, or concerts at Truliant Amphitheater—all part of the everyday appeal of <a href=\"/neighborhood\">apartments in University City Charlotte</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-fe44-75fa-a340-cb7a05a192da.webp",
  "property_featured_image_media": {
    "alt_text": "Modern white kitchen with stainless steel appliances, quartz countertops, and subway tile backsplash.",
    "public_id": "019d02f2-fe44-75fa-a340-cb7a05a192da",
    "storage_key": "property/5706772312489984/019d02f2-fe44-75fa-a340-cb7a05a192da.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "279",
  "property_year_built": "2005",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.54838709677419",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $400 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $499",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://thebellamyalm.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://thebellamy.loftliving.com/login",
  "property_apply_now_url": "https://thebellamyalm.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f1-2b7b-7438-9020-443d63cb75e8.webp",
  "property_primary_logo_media": {
    "alt_text": "The Bellamy logo with a geometric pattern.",
    "public_id": "019d02f1-2b7b-7438-9020-443d63cb75e8",
    "storage_key": "property/5706772312489984/019d02f1-2b7b-7438-9020-443d63cb75e8.webp",
    "width": 1920,
    "height": 1003
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-f0e1-7406-befc-b844a6286888.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo.",
    "public_id": "019d02f2-f0e1-7406-befc-b844a6286888",
    "storage_key": "property/5706772312489984/019d02f2-f0e1-7406-befc-b844a6286888.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e7066-d311-71b2-9a9e-76c905881891.webp",
  "property_icon_media": {
    "alt_text": "Logo with letter B on a geometric background.",
    "public_id": "019e7066-d311-71b2-9a9e-76c905881891",
    "storage_key": "property/5706772312489984/019e7066-d311-71b2-9a9e-76c905881891.webp",
    "width": 1715,
    "height": 1715
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e7066-d311-71b2-9a9e-76c905881891.webp",
  "property_fav_icon_media": {
    "alt_text": "Logo with letter B on a geometric background.",
    "public_id": "019e7066-d311-71b2-9a9e-76c905881891",
    "storage_key": "property/5706772312489984/019e7066-d311-71b2-9a9e-76c905881891.webp",
    "width": 1715,
    "height": 1715
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e7066-d81a-74ec-9212-8e78393e91a4.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Bellamy logo",
    "public_id": "019e7066-d81a-74ec-9212-8e78393e91a4",
    "storage_key": "property/5706772312489984/019e7066-d81a-74ec-9212-8e78393e91a4.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e7066-d7ce-71dd-b813-7ea3fd07ce10.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Bellamy logo",
    "public_id": "019e7066-d7ce-71dd-b813-7ea3fd07ce10",
    "storage_key": "property/5706772312489984/019e7066-d7ce-71dd-b813-7ea3fd07ce10.webp",
    "width": 3072,
    "height": 3072
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#3a3834",
  "property_secondary_color": "#c5a173",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#808285",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1.5 - 2",
  "property_bathrooms_min": "1.5",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1014 - 1416",
  "property_sqft_min": "1014",
  "property_sqft_max": "1416",
  "property_price_range": "1426 - 2412",
  "property_price_min": "1426",
  "property_price_max": "2412",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/thebellamyapartments",
  "property_instagram_url": "https://www.instagram.com/thebellamyapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJMQQO52kcVIgRfI7FTJSjLTQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Charlotte%2C+NC+28269&start=60",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that make every day flow.</strong> At The Bellamy, University City living comes with space to move, unwind, and stay on track—from a 24-hour fitness center and resort-style pool to a lighted tennis court, car care center, package lockers, and online resident services. Inside, stainless steel appliances, granite or quartz countertops, in-home washer/dryer, and generous walk-in closets add polish where it counts, with select homes offering vaulted ceilings, private courtyards, or villa-style charm.</p>",
  "property_home_floorplans_blurb": "<p><strong>Room to choose, finishes to love.</strong> Explore one-bedroom layouts with 1.5 baths, spacious two-bedroom, two-bath plans, and three-bedroom apartments in Charlotte’s University City North area. Inside, polished details like stainless steel appliances, granite or quartz countertops, in-home washer/dryer, built-in microwaves, and walk-in closets add everyday ease. Select homes elevate the experience with vaulted ceilings, private courtyards, or villa-style appeal.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at The Bellamy.</strong> Flip through bright interiors with stainless steel appliances, stone-look counters, large windows, and select vaulted ceilings—then step into community scenes featuring the pool, fitness center, tennis court, and outdoor grilling areas.</p>",
  "property_home_neighborhood_blurb": "<p><strong>University City North is right outside your routine.</strong> From The Bellamy, reach Boardwalk Billy’s, Armored Cow Brewing, North Tryon shopping, and everyday errands in minutes. For fresh air, Mallard Creek and Toby Creek greenways offer paved paths near UNC Charlotte, while the LYNX Blue Line connects you to NoDa, Uptown, and South End. Explore the map, then come home to courtyards, a pool, and pet-friendly spaces.</p>",
  "property_home_reviews_blurb": "<p><strong>Service that stands out.</strong> Reviews for The Bellamy highlight a responsive on-site team, with Juan and Modesto often recognized for professional, thorough maintenance and follow-through. Residents also point to the convenient Charlotte location, friendly staff, and comfortable community feel—easy reasons to see why “Love The Bellamy” shows up in the feedback.</p>",
  "property_neighborhood_blurb": "<p><strong>Follow the energy of University City North.</strong> From The Bellamy, your routine can shift from quiet residential streets to the buzz of the University City corridor in minutes. Grab lakeside seafood and BBQ at Boardwalk Billy’s, meet up at Armored Cow Brewing, or use the map to find shopping, coffee, and quick errands around the Boardwalk and North Tryon.</p><p>When you want fresh air, Mallard Creek and Toby Creek greenways add paved routes through wooded stretches near UNC Charlotte, while the LYNX Blue Line keeps NoDa, Uptown, and South End within reach. After exploring the neighborhood, come back to courtyards, a pool, and pet-friendly spaces at home—or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Bellamy fits your Charlotte routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, with room to recharge.</strong> At The Bellamy, amenities are designed to smooth out the routine and add more ways to enjoy your downtime in University City. Start with a workout in the 24-hour fitness center, cool off by the resort-style pool, rally on the lighted tennis court, or use the car care center before your next errand run. Package lockers, online resident services, and American Landmark 360 perks help keep daily tasks moving.</p><p>Inside, polished finishes bring the same thoughtful feel home: stainless steel appliances, granite or quartz countertops, built-in microwaves, in-home washer/dryer, and generous walk-in closets. Select layouts add vaulted ceilings, private courtyards, or villa-style character. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Bellamy home?</strong> Choose from spacious one-, two-, and three-bedroom apartments with polished finishes like granite or quartz countertops, stainless steel appliances, walk-in closets, and in-home washer/dryer. Start your online application today and take the next step toward everyday ease in University City.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The Bellamy leasing team is here to help you explore spacious one-, two-, and three-bedroom apartments in University City North, from polished in-home finishes to community conveniences. Reach out today and get the details you need for your next visit.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Bellamy?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living in University City. If you need more details or want help finding the right fit, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> The Bellamy’s floor plans start with roomy one-bedroom apartments featuring 1.5 baths, then expand into two-bedroom, two-bath and three-bedroom designs with space to spread out in Charlotte’s University City North area. As you compare current availability, look for everyday upgrades that make each plan feel polished: stainless steel appliances, granite or quartz countertops, built-in microwaves, in-home washer/dryer, and generous walk-in closets. Select homes add extra character with vaulted ceilings, private courtyards, or villa-style appeal. Browse the floor plan cards below to weigh layout, pricing, and availability side by side, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your next apartment in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces in focus.</strong> Browse photos of The Bellamy and picture how each detail comes together—from bright apartment interiors with stainless steel appliances and stone-look counters to open living areas with ceiling fans, large windows, and select vaulted ceilings.</p><p>Move through the gallery to catch the moments that make the community feel complete: a sunny pool scene, a workout-ready fitness center, a tennis court set for your next match, and outdoor grilling areas made for an easy evening close to home. You can also compare roomy one-, two-, and three-bedroom layouts on the <a href=\"/floor-plans\">floor plans</a> page, explore more <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Bellamy in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Bellamy on the map.</strong> See available apartments in University City North, then zoom out to picture the quieter residential setting near transit, campus energy, lakefront dining, errands, and fresh-air escapes.</p>",
  "property_pets_blurb": "<p><strong>More room for paws, zoomies, and slow strolls.</strong> At The Bellamy, pet-friendly apartment living feels built into the everyday—not treated like an afterthought. Take your dog to the fenced pet play area when it’s time to burn off energy, then head back to a spacious one-, two-, or three-bedroom home with walk-in closets, in-home washer/dryer, and easy-care finishes that help real life stay tidy.</p><p>Cats can claim sunny window spots, dogs can stretch out without a weight limit, and your routine stays simple with online resident services, package lockers, and outdoor spaces close to home in University City. Browse the <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Bellamy fits life with your favorite companion.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at The Bellamy?</strong> Share the polished finishes, spacious floor plans, and easygoing University City North setting with a friend. Invite them to explore the community you already call home—then use the form below to send your referral.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Bellamy.</strong> Take care of home in a few clicks with 24/7 online resident services. Log in to pay rent, submit maintenance requests, and manage your account—simple support for life in your University City apartment.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from everyday living.</strong> When you read through The Bellamy reviews, a clear theme comes through: responsive service and a helpful on-site team make daily life easier. Residents regularly call out Juan and Modesto for professionalism, thorough work, and getting service requests handled with care—from small repairs to making sure the job is completed to satisfaction.</p><p>You’ll also see praise for the “nice location,” friendly staff, and a neighborly feel throughout the community. As you browse the full ratings, you can hear why residents say things like “Love The Bellamy” and continue to appreciate the support they receive at home.</p>",
  "property_created_at": "1752256570833",
  "property_scheduletour_blurb": "<p><strong>See the space for yourself.</strong> Tour The Bellamy and get a feel for spacious one-, two-, and three-bedroom apartments with polished finishes like granite or quartz countertops, stainless steel appliances, walk-in closets, and in-home washer/dryer. Book your visit and picture daily life in University City North.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The Bellamy leasing team will be in touch soon. In the meantime, picture spacious one-, two-, and three-bedroom apartments with polished finishes, plus an amenity mix that makes everyday living in University City North feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Take a closer look, from wherever you are.</strong> The Bellamy’s virtual tours let you move through the spaces that matter before you arrive in person: two community tours, a one-bedroom with 1.5 baths, multiple two-bedroom, two-bath layouts, and a spacious three-bedroom, two-bath option.</p><p>Walk room to room at your own pace and notice the details that are easier to judge in motion—open living areas, polished kitchens with stainless steel appliances and stone countertops, walk-in closets, ceiling fans, and select vaulted-ceiling moments that add extra lift. Start with the community views, compare the A1 and B1 apartment tours, then use the walkthroughs alongside <a href=\"/floor-plans\">available floor plans</a> to narrow your favorites. When you’re ready to see The Bellamy in Charlotte up close, <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_copyright": "2025 All Rights Reserved. The Bellamy",
  "property_seo_title_home": "Home | The Bellamy",
  "property_seo_description_home": "Experience luxury living at The Bellamy in Charlotte, NC. Choose from stylish one, two, or three-bedroom apartments with top-notch amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Charlotte, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at The Bellamy in Charlotte, NC! Choose from stylish one, two, and three-bedroom floor plans to suit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at The Bellamy in Charlotte, NC! Enjoy stunning amenities like a pool, dog park, and modern apartment features designed for your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Immerse yourself in The Bellamy's vibrant lifestyle in Charlotte, NC. From stunning floor plans to top-notch amenities, see why this community feels like home!",
  "property_seo_title_virtualtours": "Virtual Tours | The Bellamy Apartments",
  "property_seo_description_virtualtours": "Experience The Bellamy in Charlotte, NC! Take a virtual tour and find your perfect one, two, or three-bedroom apartment today—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Bellamy Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Bellamy in Charlotte, NC! Enjoy stylish one to three-bedroom apartments with top-notch amenities. Check out our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Unearth the charm of Charlotte, NC, at The Bellamy. Dive into local favorites and hidden gems surrounding our vibrant community, just steps from home.",
  "property_seo_title_contact": "Contact Us | The Bellamy",
  "property_seo_description_contact": "Connect with The Bellamy in Charlotte, NC! Whether you need info on our one, two, or three-bedroom floor plans, our leasing team is here to assist you.",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Get answers to your burning questions about The Bellamy in Charlotte, NC! Dive into FAQs on our floor plans, amenities, and life in our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Discover The Bellamy in Charlotte, NC! Residents enjoy stylish homes and amenities like a pool, fitness center, and dog park. Join our vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Find your perfect home at The Bellamy in Charlotte, NC! Enjoy modern amenities like a pool, fitness center, and elegant floor plans. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Bellamy",
  "property_seo_description_residentaccess": "Access The Bellamy's resident portal for seamless rent payments, maintenance requests, and community updates. Stay connected and make life easier in Charlotte, NC!",
  "property_seo_title_referafriend": "Refer A Friend | The Bellamy",
  "property_seo_description_referafriend": "Refer a friend to The Bellamy in Charlotte, NC, and enjoy rewards! Great friends make great neighbors—share the joy of living in our vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Bellamy",
  "property_seo_description_scheduletour": "Experience modern living at The Bellamy in Charlotte, NC. Schedule a tour today and uncover your perfect home amidst vibrant amenities and cozy ambiance!",
  "property_seo_title_privacy": "Privacy Policy | The Bellamy",
  "property_seo_description_privacy": "At The Bellamy in Charlotte, NC, your privacy matters. Dive into our privacy policy to learn how we protect your personal information. Your trust, our commitment.",
  "property_seo_title_accessibility": "Website Accessibility | The Bellamy",
  "property_seo_description_accessibility": "At The Bellamy in Charlotte, NC, we embrace accessibility for all. Join us in creating an inclusive community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | The Bellamy",
  "property_seo_description_sitemap": "Unveil The Bellamy’s charm in Charlotte, NC. Navigate easily through our site map to find your dream apartment and join our vibrant community today!",
  "property_seo_title_thankyou": "Thank You | The Bellamy",
  "property_seo_description_thankyou": "Thank you for connecting with The Bellamy in Charlotte! Our team will reach out soon to assist you in finding your perfect home. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651138652",
  "amenities": [
    {
      "id": "custom_e9a435c4-313f-4e0b-8657-fb4be934e649",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2cef2c73-ffc0-49cc-83b9-734aef64e45f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_107bf40e-6846-4aa2-aa07-5b4bfdb0750c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwaves",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b934058c-325e-4085-a5b2-4ef50811eaaa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Ceramic Tile Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2657f981-1471-4b94-99be-a257061deaf8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84c4ebe8-03c3-4c1a-a484-edee587bb195",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5617b706-8a3f-45c7-9869-8669199bcdb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de3aae0a-f36a-4532-a33c-2d837b0c902c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_40c9143e-a925-47d2-9390-4f474d2aa2b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "Community Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a8cce43-ae9c-4d0a-af67-c809618faea7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000622",
      "title": "Courtyard",
      "amount": "0.0000",
      "description": "Private Courtyards",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7298507c-6683-42b9-9d39-a26e30b08ade",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3a6a353-8cd6-459e-b994-3d1d6bb1a53f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000692",
      "title": "Tennis Court",
      "amount": "0.0000",
      "description": "Lighted Tennis Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb110309-aa3a-4a8d-a74a-7ace8e6fe428",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c45bd027-e1c8-4d79-b266-5344ffe869da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_fdc75d33-0e92-4fec-ae76-b3bf37ff62a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-96f8-75af-8a2b-8cb30b468281.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartments in the background.",
        "public_id": "019e89c8-96f8-75af-8a2b-8cb30b468281",
        "storage_key": "property/5706772312489984/019e89c8-96f8-75af-8a2b-8cb30b468281.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful apartment buildings. Perfect for relaxation and fun!",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartments in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75df1a7f-695c-49e9-a1a4-850a5646074c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-9715-7289-a6a8-719e44e20d11.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a large vanity, sink, bathtub, and shower curtain. Bedroom visible in the mirror.",
        "public_id": "019e89c8-9715-7289-a6a8-719e44e20d11",
        "storage_key": "property/5706772312489984/019e89c8-9715-7289-a6a8-719e44e20d11.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity, a bathtub, and decorative shower curtains. The reflection in the mirror reveals a glimpse of the bedroom.",
      "link": "",
      "alt_text": "Modern bathroom with a large vanity, sink, bathtub, and shower curtain. Bedroom visible in the mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_36af7e82-a4eb-4f53-990c-6d2b75945aa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-8497-713e-8e18-6d9ed500a0f7.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with a ramp, tunnel, and benches.",
        "public_id": "019e89c8-8497-713e-8e18-6d9ed500a0f7",
        "storage_key": "property/5706772312489984/019e89c8-8497-713e-8e18-6d9ed500a0f7.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize. Features include agility equipment and comfortable seating.",
      "link": "",
      "alt_text": "Fenced-in dog park with a ramp, tunnel, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9ebc10f3-2b80-4a1e-8ad0-7a88ab6ec564",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-87c4-76bd-974c-c47fb9a5c497.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, botanical wallpaper, and modern furniture.",
        "public_id": "019e89c8-87c4-76bd-974c-c47fb9a5c497",
        "storage_key": "property/5706772312489984/019e89c8-87c4-76bd-974c-c47fb9a5c497.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully decorated bedroom. Featuring a plush queen bed, accent botanical wallpaper, and contemporary nightstands and dressers.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, botanical wallpaper, and modern furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7e77a63-6013-4b98-a740-ec28800b674d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-85c2-715d-af82-17f3fecbdadd.webp",
      "image_media": {
        "alt_text": "Gym equipment, including treadmills, weight machines, and dumbbells.",
        "public_id": "019e89c8-85c2-715d-af82-17f3fecbdadd",
        "storage_key": "property/5706772312489984/019e89c8-85c2-715d-af82-17f3fecbdadd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio machines, weight training equipment, and free weights.",
      "link": "",
      "alt_text": "Gym equipment, including treadmills, weight machines, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c5fea788-75fb-4642-8ecc-210fc3d89011",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-81be-7607-ad93-d9d2ec6436c4.webp",
      "image_media": {
        "alt_text": "Modern living room with fireplace, TV, and seating area.",
        "public_id": "019e89c8-81be-7607-ad93-d9d2ec6436c4",
        "storage_key": "property/5706772312489984/019e89c8-81be-7607-ad93-d9d2ec6436c4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and stylish living area, complete with a cozy fireplace and modern entertainment setup.",
      "link": "",
      "alt_text": "Modern living room with fireplace, TV, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2025475f-c7c8-4e25-988e-96d3ad5e6db8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-8105-758e-970d-4ebcd8759248.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in barbecues, bar seating, and umbrellas.",
        "public_id": "019e89c8-8105-758e-970d-4ebcd8759248",
        "storage_key": "property/5706772312489984/019e89c8-8105-758e-970d-4ebcd8759248.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy convenient outdoor cooking with our community grilling stations, complete with ample seating and shade.",
      "link": "",
      "alt_text": "Outdoor grilling station with two built-in barbecues, bar seating, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46f9416f-687c-474d-96b1-77f1442585da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-849e-7674-9951-e61f8094ce8e.webp",
      "image_media": {
        "alt_text": "A home office setup with a wooden desk, office chair, and decorative curtains.",
        "public_id": "019e89c8-849e-7674-9951-e61f8094ce8e",
        "storage_key": "property/5706772312489984/019e89c8-849e-7674-9951-e61f8094ce8e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this stylish home office, featuring a modern desk, comfortable seating, and elegant window treatments.",
      "link": "",
      "alt_text": "A home office setup with a wooden desk, office chair, and decorative curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a1c018f-168e-4d43-9ff2-1ef9d09804d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-808f-7109-8fea-1b8fa7e33d03.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, bathtub, and separate shower.",
        "public_id": "019e89c8-808f-7109-8fea-1b8fa7e33d03",
        "storage_key": "property/5706772312489984/019e89c8-808f-7109-8fea-1b8fa7e33d03.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom featuring a spacious double vanity, a relaxing bathtub, and a sleek separate shower, perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, bathtub, and separate shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b17ec7f3-29d8-43bc-a554-b258df652ee1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-7aae-73bc-a079-dabbcfada957.webp",
      "image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs. Tennis court in the background.",
        "public_id": "019e89c8-7aae-73bc-a079-dabbcfada957",
        "storage_key": "property/5706772312489984/019e89c8-7aae-73bc-a079-dabbcfada957.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and relax on the sun loungers at our apartment community. Features a tennis court for active recreation.",
      "link": "",
      "alt_text": "Apartment complex with a large swimming pool and lounge chairs. Tennis court in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58b47185-bdf8-4c7c-83e5-ec916ce039f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-7c40-73af-9f1a-02d26d1fb5be.webp",
      "image_media": {
        "alt_text": "Street view of townhouses with garages and driveways, lined with trees and green lawns under a blue sky.",
        "public_id": "019e89c8-7c40-73af-9f1a-02d26d1fb5be",
        "storage_key": "property/5706772312489984/019e89c8-7c40-73af-9f1a-02d26d1fb5be.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Experience comfortable living in this charming community featuring beautiful townhouses with attached garages, set amidst lush greenery and well-maintained landscaping.",
      "link": "",
      "alt_text": "Street view of townhouses with garages and driveways, lined with trees and green lawns under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a522c0ab-3940-44d1-aa9d-52d5dd105f30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-7ab3-74cf-960e-3ccc98dc1db6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white subway tile backsplash, black marble island, and stainless steel appliances.",
        "public_id": "019e89c8-7ab3-74cf-960e-3ccc98dc1db6",
        "storage_key": "property/5706772312489984/019e89c8-7ab3-74cf-960e-3ccc98dc1db6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Sleek and stylish kitchen featuring white subway tile, a dramatic black marble island, and a suite of modern appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white subway tile backsplash, black marble island, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_880b6251-c42a-4f51-bb36-e4d30a2907cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-6277-72ed-89c4-121112b0e223.webp",
      "image_media": {
        "alt_text": "Tennis court with apartment buildings in the background",
        "public_id": "019e89c8-6277-72ed-89c4-121112b0e223",
        "storage_key": "property/5706772312489984/019e89c8-6277-72ed-89c4-121112b0e223.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our on-site tennis court, surrounded by beautiful landscaping and apartment buildings.",
      "link": "",
      "alt_text": "Tennis court with apartment buildings in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b3596bc-91f5-4cae-aa7d-9dcae24a16fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-6262-76de-b870-acd65ae48c4e.webp",
      "image_media": {
        "alt_text": "Living room with a tan sofa, coffee table, TV, and a desk area.",
        "public_id": "019e89c8-6262-76de-b870-acd65ae48c4e",
        "storage_key": "property/5706772312489984/019e89c8-6262-76de-b870-acd65ae48c4e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern living room featuring a comfortable tan sofa, a stylish coffee table, and a wall-mounted TV, perfect for relaxation and entertainment. Includes a dedicated workspace.",
      "link": "",
      "alt_text": "Living room with a tan sofa, coffee table, TV, and a desk area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0fe1a87-b557-4fd9-b487-8b4f487235e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-60d9-742d-b4e6-e5da5179376e.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property featuring a swimming pool, tennis court, and apartment buildings.",
        "public_id": "019e89c8-60d9-742d-b4e6-e5da5179376e",
        "storage_key": "property/5706772312489984/019e89c8-60d9-742d-b4e6-e5da5179376e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover luxury living at our multifamily property, boasting a sparkling swimming pool, a tennis court, and beautifully landscaped grounds.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property featuring a swimming pool, tennis court, and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4faff305-2cd4-4811-a932-a9c39658694f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-61c4-763f-b443-054284634e84.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e89c8-61c4-763f-b443-054284634e84",
        "storage_key": "property/5706772312489984/019e89c8-61c4-763f-b443-054284634e84.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by comfortable lounge seating and beautiful landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e66f0af0-e5f0-4cdb-933a-d233a01676c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-6499-7619-b498-56c533beb8a3.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, large mirror, and decorative plants.",
        "public_id": "019e89c8-6499-7619-b498-56c533beb8a3",
        "storage_key": "property/5706772312489984/019e89c8-6499-7619-b498-56c533beb8a3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and stylish bedroom featuring a comfortable king-size bed with patterned linens, a full-length mirror, and an abundance of natural light. Perfect for relaxation and unwinding.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, large mirror, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85060f51-f0ca-4a93-97ca-453857a92e8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-667c-761b-a0f4-9840257260de.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with two garages and a white picket fence.",
        "public_id": "019e89c8-667c-761b-a0f4-9840257260de",
        "storage_key": "property/5706772312489984/019e89c8-667c-761b-a0f4-9840257260de.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Beautifully maintained exterior of an apartment building, featuring two attached garages and charming landscaping.",
      "link": "",
      "alt_text": "Exterior of a brick apartment building with two garages and a white picket fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de0e2648-bf87-4580-9546-c7fa7439745a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-657a-779f-941a-796245c3f3b7.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, elliptical, stationary bike, and rowing machine.",
        "public_id": "019e89c8-657a-779f-941a-796245c3f3b7",
        "storage_key": "property/5706772312489984/019e89c8-657a-779f-941a-796245c3f3b7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with top-tier cardio machines for a complete workout.",
      "link": "",
      "alt_text": "Modern fitness center with treadmills, elliptical, stationary bike, and rowing machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_206e2e40-7ea0-462d-afa3-36b9f1f5a5f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-67b7-7789-af60-f9ee23b105ba.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019e89c8-67b7-7789-af60-f9ee23b105ba",
        "storage_key": "property/5706772312489984/019e89c8-67b7-7789-af60-f9ee23b105ba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring white shaker cabinets, gleaming stainless steel appliances, and elegant quartz countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b47decdf-b3b8-4e9f-b142-e887170f8eda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-5fd3-76dd-9e54-3e93eacdffac.webp",
      "image_media": {
        "alt_text": "Fitness center with two spin bikes, medicine balls, resistance bands, and yoga mats.",
        "public_id": "019e89c8-5fd3-76dd-9e54-3e93eacdffac",
        "storage_key": "property/5706772312489984/019e89c8-5fd3-76dd-9e54-3e93eacdffac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio equipment, weights, and more.",
      "link": "",
      "alt_text": "Fitness center with two spin bikes, medicine balls, resistance bands, and yoga mats.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac0fbb4d-63c6-444e-bd83-fb169ae79c81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-5ca6-74e9-9b82-3ee1720fc393.webp",
      "image_media": {
        "alt_text": "Playground with slide and swings at a multifamily property.",
        "public_id": "019e89c8-5ca6-74e9-9b82-3ee1720fc393",
        "storage_key": "property/5706772312489984/019e89c8-5ca6-74e9-9b82-3ee1720fc393.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with a slide and swings for residents of all ages.",
      "link": "",
      "alt_text": "Playground with slide and swings at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4be486f4-d2fd-4a0a-a290-3874206b7d06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-4bc4-71b4-9ef6-fd5bd6fa6da5.webp",
      "image_media": {
        "alt_text": "Modern living room with a tan sofa, coffee table, TV, and a glimpse of the kitchen.",
        "public_id": "019e89c8-4bc4-71b4-9ef6-fd5bd6fa6da5",
        "storage_key": "property/5706772312489984/019e89c8-4bc4-71b4-9ef6-fd5bd6fa6da5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable tan sofa, a modern coffee table, and a wall-mounted TV. The open-concept design includes a visible dining area and kitchen.",
      "link": "",
      "alt_text": "Modern living room with a tan sofa, coffee table, TV, and a glimpse of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c3a2814-c6be-4136-b74e-78919d432368",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-4ab8-71f0-afff-e17b41a27736.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding, balconies, and a parking lot.",
        "public_id": "019e89c8-4ab8-71f0-afff-e17b41a27736",
        "storage_key": "property/5706772312489984/019e89c8-4ab8-71f0-afff-e17b41a27736.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Spacious apartment buildings featuring a mix of brick and siding exteriors, private balconies, and ample parking. Enjoy a comfortable living experience in this well-maintained community.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and siding, balconies, and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ceb2829-1553-4f76-a7df-d0474c2c2790",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-4bb1-770f-a06d-b9f01b498e82.webp",
      "image_media": {
        "alt_text": "Exterior view of a charming single-story apartment building with a two-car garage and well-maintained landscaping.",
        "public_id": "019e89c8-4bb1-770f-a06d-b9f01b498e82",
        "storage_key": "property/5706772312489984/019e89c8-4bb1-770f-a06d-b9f01b498e82.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover your new home in this beautifully appointed apartment building, featuring a spacious two-car garage and surrounded by lush greenery and manicured lawns.",
      "link": "",
      "alt_text": "Exterior view of a charming single-story apartment building with a two-car garage and well-maintained landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0cf223f2-de0c-4bc8-9d21-f3b9e3c8ee36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019e89c8-49f5-74d7-ad58-525c222f83c4.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a round table and green chairs.",
        "public_id": "019e89c8-49f5-74d7-ad58-525c222f83c4",
        "storage_key": "property/5706772312489984/019e89c8-49f5-74d7-ad58-525c222f83c4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen and dining area featuring white cabinetry, stainless steel appliances, and a stylish round table with plush green chairs, perfect for intimate meals.",
      "link": "",
      "alt_text": "Kitchen and dining area with a round table and green chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_fbc212f99a91102e319b23cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "131 MAIN Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9886 Rea Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "Refined New American dishes served along with wines & spirits in a smart-casual setting.",
      "poi_long_description": "Refined New American dishes served along with wines & spirits in a smart-casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-f91e-77aa-8eb7-df46575e4887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-f91e-77aa-8eb7-df46575e4887",
        "storage_key": "property/5706772312489984/019f14f9-f91e-77aa-8eb7-df46575e4887.webp",
        "width": 923,
        "height": 686
      },
      "poi_business_url": "https://www.131-main.com/blakeney/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12060129007547035525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "131-main-restaurant",
      "poi_latitude": "35.034089",
      "poi_longitude": "-80.808956",
      "poi_miles_from_property": "23.5 mi",
      "poi_walking_minutes": "8 hours 42 mins",
      "poi_biking_minutes": "2 hours 39 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 704-544-0131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZixZQIoVIgRha85YG8vXqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_4c21266dcb184d4ecb4382c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Greco Fresh Grille - Blakeney",
      "poi_type": "Restaurants",
      "poi_address": "9820 Rea Rd Blakeney, Charlotte, NC 28277, USA",
      "poi_short_description": "Family-owned, casual grill providing familiar Mediterranean fare at the counter & outdoor seating.",
      "poi_long_description": "Family-owned, casual grill providing familiar Mediterranean fare at the counter & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-fdba-743f-a146-99d5d1408b16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-fdba-743f-a146-99d5d1408b16",
        "storage_key": "property/5706772312489984/019f14f9-fdba-743f-a146-99d5d1408b16.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.grecofreshgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17699889523583771755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greco-fresh-grille---blakeney",
      "poi_latitude": "35.0346742",
      "poi_longitude": "-80.805725",
      "poi_miles_from_property": "23.4 mi",
      "poi_walking_minutes": "8 hours 40 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 704-542-7770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2vT6gMoVIgRa2TeYL6jovU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_fe69a659f6484cdbdb698344",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Brixx Wood Fired Pizza + Craft Bar",
      "poi_type": "Restaurants",
      "poi_address": "9820 Rea Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "Part of a chain featuring pizza from a wood-fired brick oven, plus sandwiches & craft beers.",
      "poi_long_description": "Part of a chain featuring pizza from a wood-fired brick oven, plus sandwiches & craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-fd13-713a-947f-9a375fc2e2b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-fd13-713a-947f-9a375fc2e2b5",
        "storage_key": "property/5706772312489984/019f14f9-fd13-713a-947f-9a375fc2e2b5.webp",
        "width": 604,
        "height": 1280
      },
      "poi_business_url": "https://brixxpizza.com/?y_source=1_MTUwMzMzMzktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11601960589820830222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brixx-wood-fired-pizza--craft-bar",
      "poi_latitude": "35.0345855",
      "poi_longitude": "-80.80592159999999",
      "poi_miles_from_property": "23.4 mi",
      "poi_walking_minutes": "8 hours 40 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 704-940-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2vT6gMoVIgRDiJaxq9xAqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_e8889080a42e5d3b54f97c6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Open Rice Blakeney",
      "poi_type": "Restaurants",
      "poi_address": "9882 Rea Rd F, Charlotte, NC 28277, USA",
      "poi_short_description": "Hip, light-filled, modern eatery serving dishes influenced by across the Asian continent, from Hong Kong-style roasted duck to kimchi fried rice.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-fef6-700c-815c-335912236e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-fef6-700c-815c-335912236e23",
        "storage_key": "property/5706772312489984/019f14f9-fef6-700c-815c-335912236e23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.openriceclt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1739095794239637013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "open-rice-blakeney",
      "poi_latitude": "35.0350221",
      "poi_longitude": "-80.8091962",
      "poi_miles_from_property": "23.4 mi",
      "poi_walking_minutes": "8 hours 41 mins",
      "poi_biking_minutes": "2 hours 39 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 980-406-3894",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2XSNFspVIgRFYYHJmmCIhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "ec_60898330a17e3ef70e1fa8d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Burtons Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "9816 Rea Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "Upscale bar & grill chain featuring an extensive menu of American fare in a stylish dining room.",
      "poi_long_description": "Upscale bar & grill chain featuring an extensive menu of American fare in a stylish dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-f963-740b-9f21-4f0ee87cdb04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-f963-740b-9f21-4f0ee87cdb04",
        "storage_key": "property/5706772312489984/019f14f9-f963-740b-9f21-4f0ee87cdb04.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://burtonsgrill.com/locations/nc/charlotte-blakeney/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3496124494453180512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burtons-grill--bar",
      "poi_latitude": "35.0354912",
      "poi_longitude": "-80.80610879999999",
      "poi_miles_from_property": "23.4 mi",
      "poi_walking_minutes": "8 hours 39 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 980-701-0910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUb5muispVIgRYIhsVrS6hDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_b74487ffb68f701be2d18910",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Rai Lay Blakeney",
      "poi_type": "Restaurants",
      "poi_address": "9935 Rea Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "Sushi & Japanese entrees in a space with high ceilings, red walls & a sleek, glowing bar.",
      "poi_long_description": "Sushi & Japanese entrees in a space with high ceilings, red walls & a sleek, glowing bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-fe35-708e-be30-98c6c8639711.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-fe35-708e-be30-98c6c8639711",
        "storage_key": "property/5706772312489984/019f14f9-fe35-708e-be30-98c6c8639711.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://railayblakeney.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=998450989111150695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rai-lay-blakeney",
      "poi_latitude": "35.0338994",
      "poi_longitude": "-80.8046967",
      "poi_miles_from_property": "23.4 mi",
      "poi_walking_minutes": "8 hours 40 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 704-845-1801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBRTVaakpVIgRZ4ibc-I12w0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_272fb8f9fd364a16e5d3f57e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Shake Shack Blakeney",
      "poi_type": "Restaurants",
      "poi_address": "9824 Rea Rd A, Charlotte, NC 28277, USA",
      "poi_short_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_long_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-02db-74cd-b922-4bcc369bb686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-02db-74cd-b922-4bcc369bb686",
        "storage_key": "property/5706772312489984/019f14fa-02db-74cd-b922-4bcc369bb686.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shakeshack.com/location/blakeney-nc?utm_source=google&utm_medium=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2273877858819057824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shake-shack-blakeney",
      "poi_latitude": "35.03433",
      "poi_longitude": "-80.80637",
      "poi_miles_from_property": "23.4 mi",
      "poi_walking_minutes": "8 hours 41 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 980-221-1821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEw31lsUpVIgRoCiJdd1vjh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_e0804fa1cd97f7973cc50651",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10001 Rea Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-fbc3-744e-abb0-51c00df5b713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-fbc3-744e-abb0-51c00df5b713",
        "storage_key": "property/5706772312489984/019f14f9-fbc3-744e-abb0-51c00df5b713.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nc/blakeney?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5597114925544804451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.0330146",
      "poi_longitude": "-80.8048428",
      "poi_miles_from_property": "23.6 mi",
      "poi_walking_minutes": "8 hours 44 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 704-844-0704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL1hHggMoVIgRY5AiuF7yrE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_3d0bbee8b0a21369c1d338f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Rooster's Wood-fired Kitchen Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15110 Bowl St #101, Charlotte, NC 28277, USA",
      "poi_short_description": "Upscale menu of Southern food & dishes with international influences made from local ingredients.",
      "poi_long_description": "Upscale menu of Southern food & dishes with international influences made from local ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f9-fdcb-76df-b21c-30bcbab1e7a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-fdcb-76df-b21c-30bcbab1e7a2",
        "storage_key": "property/5706772312489984/019f14f9-fdcb-76df-b21c-30bcbab1e7a2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.roosterskitchen.com/ballantyne",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093347024850541206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosters-wood-fired-kitchen-ballantyne",
      "poi_latitude": "35.0573504",
      "poi_longitude": "-80.84518539999999",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 22 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 980-366-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRUUGiWdVogRllqy_o3EN-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_554bb6fafd8691d39b3a8279",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Postino Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15210 Bowl St #103, Charlotte, NC 28277, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0264-711a-8813-f70ae97851eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0264-711a-8813-f70ae97851eb",
        "storage_key": "property/5706772312489984/019f14fa-0264-711a-8813-f70ae97851eb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.postinowinecafe.com/locations/postino-ballantyne?utm_source=Google&utm_medium=Listing_CTA&utm_campaign=Google&utm_content=Ballantyne",
      "poi_directions_map_url": "https://maps.google.com/?cid=14940076803823768014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "postino-ballantyne",
      "poi_latitude": "35.0585198",
      "poi_longitude": "-80.8457085",
      "poi_miles_from_property": "22.5 mi",
      "poi_walking_minutes": "8 hours 21 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 704-512-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b1a-742b-a1c1-8a35e2ef74e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b1a-742b-a1c1-8a35e2ef74e6",
        "storage_key": "property/5706772312489984/019f14fa-4b1a-742b-a1c1-8a35e2ef74e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyt_f2GdVogRzhH4eLLQVc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_0fc9988d14d76bbe0e655b72",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "North Italia",
      "poi_type": "Restaurants",
      "poi_address": "15120 Bowl St #102, Charlotte, NC 28277, USA",
      "poi_short_description": "Laid-back, trendy chain eatery for Italian fare such as pizza, pasta and cocktails in modern surroundings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-041f-757b-a29b-68b0661a007e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-041f-757b-a29b-68b0661a007e",
        "storage_key": "property/5706772312489984/019f14fa-041f-757b-a29b-68b0661a007e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.northitalia.com/locations/ballantyne-nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18408571823897907174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-italia",
      "poi_latitude": "35.0579049",
      "poi_longitude": "-80.84532",
      "poi_miles_from_property": "22.5 mi",
      "poi_walking_minutes": "8 hours 22 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 980-431-6225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcVBmnidVogR5g-zgYpieP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_6e31336d1ef5e700eb53ee9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "The Olde Mecklenburg Restaurant & Biergarten at Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15025 Bowl St, Charlotte, NC 28277, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0727-73b9-a7e1-31001d15a094.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0727-73b9-a7e1-31001d15a094",
        "storage_key": "property/5706772312489984/019f14fa-0727-73b9-a7e1-31001d15a094.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ombbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5238904532443810007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olde-mecklenburg-restaurant--biergarten-at-ballantyne",
      "poi_latitude": "35.0566421",
      "poi_longitude": "-80.84553489999999",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 23 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 984-253-1980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b1a-742b-a1c1-8a35e2ef74e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b1a-742b-a1c1-8a35e2ef74e6",
        "storage_key": "property/5706772312489984/019f14fa-4b1a-742b-a1c1-8a35e2ef74e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTT5Io16dVogR10h_VOpTtEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "beer_garden"
    },
    {
      "id": "ec_e864bcb06f9699ee889d22d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Flower Child",
      "poi_type": "Restaurants",
      "poi_address": "15210 Bowl St #101, Charlotte, NC 28277, USA",
      "poi_short_description": "Casual eatery (part of a chain) serving bowls, wraps, salads and kabobs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-05a0-72aa-9088-7b13ac08566c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-05a0-72aa-9088-7b13ac08566c",
        "storage_key": "property/5706772312489984/019f14fa-05a0-72aa-9088-7b13ac08566c.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.iamaflowerchild.com/locations/flower-child-charlotte-ballantyne/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17187131514142165411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flower-child",
      "poi_latitude": "35.0583156",
      "poi_longitude": "-80.8455975",
      "poi_miles_from_property": "22.5 mi",
      "poi_walking_minutes": "8 hours 21 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 980-279-5793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaJvtuWdVogRo4ldAA31hO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_c634c5682d81424777d027ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Harriet's Hamburgers | Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15109 Bowl St, Charlotte, NC 28277, USA",
      "poi_short_description": "Informal eatery serving hamburgers (some with all-natural meat), cheese curds, fries (including the crispy type), beer, sodas and shakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-08c9-7400-963e-88e0632223bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-08c9-7400-963e-88e0632223bd",
        "storage_key": "property/5706772312489984/019f14fa-08c9-7400-963e-88e0632223bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://harrietshamburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15225374187435692128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harriets-hamburgers--ballantyne",
      "poi_latitude": "35.0572917",
      "poi_longitude": "-80.84557099999999",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 22 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 704-619-8267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cifmMGdVogRYJCB7idlS9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_73551e8617ee090b65764f87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Bossy Beulah's Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15110 Bowl St #103, Charlotte, NC 28277, USA",
      "poi_short_description": "Fried, flavorful chicken sandwiches are the specialty at this casual eatery with outdoor seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-092a-731a-8991-8ce822aff564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-092a-731a-8991-8ce822aff564",
        "storage_key": "property/5706772312489984/019f14fa-092a-731a-8991-8ce822aff564.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://bossybeulahs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8953534312420350164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bossy-beulahs-ballantyne",
      "poi_latitude": "35.0574827",
      "poi_longitude": "-80.845114",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 22 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 980-366-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c9-71ca-b578-8276ac656fe4",
        "storage_key": "property/5706772312489984/019d02f2-21c9-71ca-b578-8276ac656fe4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9hkSUadVogR1BgW8ARYQXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_e86b29adaa0a6e55067f6321",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "8909 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0732-714f-a109-4ec4e8a0b235.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0732-714f-a109-4ec4e8a0b235",
        "storage_key": "property/5706772312489984/019f14fa-0732-714f-a109-4ec4e8a0b235.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6540-charlotte-nc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14024923655885904457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "35.3146716",
      "poi_longitude": "-80.7545248",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-593-0227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-222d-71fc-af0d-0f53ef863149",
        "storage_key": "property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdaxbCDocVIgRSVoN_8GJosI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_1d2a9af301238cc18233ea93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "9323 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocer with a specialty pastry section selling cookies, and beer and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0c3f-70bc-8791-a5f043f8fdac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0c3f-70bc-8791-a5f043f8fdac",
        "storage_key": "property/5706772312489984/019f14fa-0c3f-70bc-8791-a5f043f8fdac.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.foodlion.com/nc/charlotte/9323-n-tryon-st?y_source=1_NTA0NjkwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14276779664295595948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.3140856",
      "poi_longitude": "-80.7444611",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-547-0248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2227-757e-9dc0-a30d8c9b2c83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2227-757e-9dc0-a30d8c9b2c83",
        "storage_key": "property/5706772312489984/019d02f2-2227-757e-9dc0-a30d8c9b2c83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYe47j0cVIgRrA_cinZPIcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_97984d80b112c5ac33f7f2d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7735 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocery store, pharmacy, clothing, furniture, sporting goods, electronics, home goods and sporting goods retailer featuring clothing, housewares, electronics and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0aa3-731a-89b3-4bf00e79aa5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0aa3-731a-89b3-4bf00e79aa5f",
        "storage_key": "property/5706772312489984/019f14fa-0aa3-731a-89b3-4bf00e79aa5f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2134-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7693588847703310125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.2951583",
      "poi_longitude": "-80.7581024",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-547-0525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-222d-71fc-af0d-0f53ef863149",
        "storage_key": "property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9wzzDDAcVIgRLT9Da0sexWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_88096b5a47e6be2bc670728f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11530 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Clean supermarket with everyday groceries and a variety of products at low prices.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0c42-71fc-af0e-860a570eeac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0c42-71fc-af0e-860a570eeac5",
        "storage_key": "property/5706772312489984/019f14fa-0c42-71fc-af0e-860a570eeac5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/6233-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1734489702722648400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.3341357",
      "poi_longitude": "-80.7125191",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-428-8134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2227-757e-9dc0-a30d8c9b2c83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2227-757e-9dc0-a30d8c9b2c83",
        "storage_key": "property/5706772312489984/019d02f2-2227-757e-9dc0-a30d8c9b2c83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkym2fIMbVIgRUDlb5TElEhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_cbee23f5d1b7857f86b0ac4a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1820 E Arbors Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f1-ca8d-70f9-b854-dfca8f66643e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-ca8d-70f9-b854-dfca8f66643e",
        "storage_key": "property/5706772312489984/019d02f1-ca8d-70f9-b854-dfca8f66643e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.traderjoes.com/nc/charlotte/743/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11134565066821536978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.3367688",
      "poi_longitude": "-80.7545798",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-688-9578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2227-757e-9dc0-a30d8c9b2c83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2227-757e-9dc0-a30d8c9b2c83",
        "storage_key": "property/5706772312489984/019d02f2-2227-757e-9dc0-a30d8c9b2c83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsT5BqFAcVIgR0gxfUO_rhZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_83cada3e8c6a39f6823aef93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10515 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0c38-737d-8a02-563f11512971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0c38-737d-8a02-563f11512971",
        "storage_key": "property/5706772312489984/019f14fa-0c38-737d-8a02-563f11512971.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/10515-mallard-creek-road-charlotte-nc-28262/storeid=2559?WT.mc_id=LS_GOOGLE_RX_2559",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047423090634507296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3424104",
      "poi_longitude": "-80.7676571",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-547-9739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b1a-742b-a1c1-8cc092e9c025.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b1a-742b-a1c1-8cc092e9c025",
        "storage_key": "property/5706772312489984/019f14fa-4b1a-742b-a1c1-8cc092e9c025.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_Q8k6odVIgRIMQbkHgLMac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9d265669f36124095bfe4235",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "8300 Ikea Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-0ba0-71bb-9c60-cedbdbc817e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-0ba0-71bb-9c60-cedbdbc817e5",
        "storage_key": "property/5706772312489984/019f14f6-0ba0-71bb-9c60-cedbdbc817e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/charlotte/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=charlotte",
      "poi_directions_map_url": "https://maps.google.com/?cid=8666071200226601882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "35.2935168",
      "poi_longitude": "-80.7647415",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-222d-71fc-af0d-0f53ef863149",
        "storage_key": "property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNUGiFYceVIgRmuu_f9cRRHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_bf9b24d4a0325e0e64f0d685",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "8150 Ikea Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-10e0-77ba-9046-824adc721edd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-10e0-77ba-9046-824adc721edd",
        "storage_key": "property/5706772312489984/019f14fa-10e0-77ba-9046-824adc721edd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11113569713696847354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "35.2971519",
      "poi_longitude": "-80.7628314",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-494-8723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-222d-71fc-af0d-0f53ef863149",
        "storage_key": "property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTSOiEJ8eVIgR-rVwu8VUO5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_d47cec5fb16de3621a4508a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "7010 University City Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Gas station and convenience store offering premium fuels and a variety of products.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-115a-75cf-9a9a-058f30e8b36f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-115a-75cf-9a9a-058f30e8b36f",
        "storage_key": "property/5706772312489984/019f14fa-115a-75cf-9a9a-058f30e8b36f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/charlotte/7010-university-city-blvd/2703267?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2320119767414524242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "35.289537",
      "poi_longitude": "-80.765479",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-599-8787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b19-76d9-bdd5-32b0123e845b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b19-76d9-bdd5-32b0123e845b",
        "storage_key": "property/5706772312489984/019f14fa-4b19-76d9-bdd5-32b0123e845b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJiU5F-YceVIgRUskazaK4MiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_9b1eb13da238b350bf677fce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "9025 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-13a6-723e-8a22-39af12432367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-13a6-723e-8a22-39af12432367",
        "storage_key": "property/5706772312489984/019f14fa-13a6-723e-8a22-39af12432367.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/nc/charlotte/9025-mallard-creek-rd-35548?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14276073162986461104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "35.3272373",
      "poi_longitude": "-80.77370169999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-510-9515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b19-76d9-bdd5-32b0123e845b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b19-76d9-bdd5-32b0123e845b",
        "storage_key": "property/5706772312489984/019f14fa-4b19-76d9-bdd5-32b0123e845b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQ3a62rYdVIgRsJdLY-fMHsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_bf76e7c0bba4375fb228eea5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Stoney Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "14015 Mallard Roost Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-10ef-704e-9a1a-74bbaf245b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-10ef-704e-9a1a-74bbaf245b3e",
        "storage_key": "property/5706772312489984/019f14fa-10ef-704e-9a1a-74bbaf245b3e.webp",
        "width": 1200,
        "height": 570
      },
      "poi_business_url": "https://www.cmsk12.org/stoneycreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=16947952449494394279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stoney-creek-elementary-school",
      "poi_latitude": "35.3482805",
      "poi_longitude": "-80.7253375",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-344-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq8y7u4McVIgRpyVTbvU4M-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a79b4af35f1efd5c1e73eac4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "University Meadows Elementary School",
      "poi_type": "Education",
      "poi_address": "1600 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1533-776b-b2d2-8301f71152ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1533-776b-b2d2-8301f71152ec",
        "storage_key": "property/5706772312489984/019f14fa-1533-776b-b2d2-8301f71152ec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cmsk12.org/universitymeadowsES",
      "poi_directions_map_url": "https://maps.google.com/?cid=4346912931435958724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-meadows-elementary-school",
      "poi_latitude": "35.315458",
      "poi_longitude": "-80.71452599999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-3685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz26ydPMbVIgRxNHKu0dWUzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e1f9b9f6d11f67075541783a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "James Martin Middle School",
      "poi_type": "Education",
      "poi_address": "6301 University Pointe Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1b69-7370-9feb-a58950479ea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1b69-7370-9feb-a58950479ea0",
        "storage_key": "property/5706772312489984/019f14fa-1b69-7370-9feb-a58950479ea0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/jamesmartinMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5618926938611783760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-martin-middle-school",
      "poi_latitude": "35.2994377",
      "poi_longitude": "-80.7661055",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-5382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsavmwH8eVIgRUBjUwkdw-k0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_c19902d1ac56ae4a1a5ce37d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Julius L. Chambers High School",
      "poi_type": "Education",
      "poi_address": "7600 IBM Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1345-749e-bd98-66701d9a639a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1345-749e-bd98-66701d9a639a",
        "storage_key": "property/5706772312489984/019f14fa-1345-749e-bd98-66701d9a639a.webp",
        "width": 413,
        "height": 275
      },
      "poi_business_url": "https://www.cmsk12.org/chambersHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17524243692802135939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julius-l-chambers-high-school",
      "poi_latitude": "35.3008041",
      "poi_longitude": "-80.76758769999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-5284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYSZQhk8mVIgRg9fZisqeMvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_60acb6175bca7c893c528f29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Mallard Creek High School",
      "poi_type": "Education",
      "poi_address": "3825 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-140a-738c-9d10-3d381dda4af3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-140a-738c-9d10-3d381dda4af3",
        "storage_key": "property/5706772312489984/019f14fa-140a-738c-9d10-3d381dda4af3.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.cmsk12.org/mallardcreekHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=6531472597723805118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-high-school",
      "poi_latitude": "35.36517",
      "poi_longitude": "-80.76934159999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-343-1341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQx6peB8dVIgRvnWG77hzpFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_efe5f73316d72c8fb3ca1ec8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Cadence Academy Preschool",
      "poi_type": "Education",
      "poi_address": "9625 Mallard Glen Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Childcare and early education center with programs for infants, toddlers, and preschoolers, plus after-school care and summer camp.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-15b6-7018-a892-559731f29afc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-15b6-7018-a892-559731f29afc",
        "storage_key": "property/5706772312489984/019f14fa-15b6-7018-a892-559731f29afc.webp",
        "width": 920,
        "height": 690
      },
      "poi_business_url": "https://www.cadence-education.com/locations/nc/charlotte/715?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=13553965360200361187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cadence-academy-preschool",
      "poi_latitude": "35.3307503",
      "poi_longitude": "-80.73863450000002",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-817-4051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP-n8AmYcVIgR4ySx4K5bGbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_b0a1def12e646472247d247f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Kids 'R' Kids Learning Academy of Charlotte",
      "poi_type": "Education",
      "poi_address": "2115 Ben Craig Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Childcare chain providing daycare, after-school programs, and summer camps in a variety of subjects.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1659-77df-8376-495884812e90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1659-77df-8376-495884812e90",
        "storage_key": "property/5706772312489984/019f14fa-1659-77df-8376-495884812e90.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.kidsrkidscharlotte.com/?utm_source=gmb_listing&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6243442820306353484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-r-kids-learning-academy-of-charlotte",
      "poi_latitude": "35.32141",
      "poi_longitude": "-80.77405",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-503-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ04VQy8kdVIgRTL3SdyoqpVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_b9080e907331ec31fe1d7d84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "University Child Development Center",
      "poi_type": "Education",
      "poi_address": "8303 University Executive Park Dr Ste 450, Charlotte, NC 28262, USA",
      "poi_short_description": "Daycare center located in the University Executive Park offering a pre-K program.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-183b-76d8-9046-12c5309ac9f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-183b-76d8-9046-12c5309ac9f3",
        "storage_key": "property/5706772312489984/019f14fa-183b-76d8-9046-12c5309ac9f3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://universitycdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3043994702130764041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-child-development-center",
      "poi_latitude": "35.3023501",
      "poi_longitude": "-80.7556594",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-549-4029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSy3gdigcVIgRCdmsxg1xPio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_603a419bcc31c0f716f6b3fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-15da-7728-815a-290870be6cb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-15da-7728-815a-290870be6cb3",
        "storage_key": "property/5706772312489984/019f14f6-15da-7728-815a-290870be6cb3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_da2fcbb2483c6dfb0758c535",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Mallard Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "9801 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1868-75da-a904-b711688939a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1868-75da-a904-b711688939a9",
        "storage_key": "property/5706772312489984/019f14fa-1868-75da-a904-b711688939a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/mallardcreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=9511436041936188988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-elementary-school",
      "poi_latitude": "35.3354412",
      "poi_longitude": "-80.7741362",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-3980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV3xM6uscVIgRPDZ0t69o_4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_14ec6c1648dcf6c12ec48ba3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "TD Amp Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "11115 Upper Ave, Charlotte, NC 28277, USA",
      "poi_short_description": "Outdoor music amphitheater also hosting films, at new Ballantyne Reimagined project.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1931-76f9-8b41-d20dd13c336d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1931-76f9-8b41-d20dd13c336d",
        "storage_key": "property/5706772312489984/019f14fa-1931-76f9-8b41-d20dd13c336d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tdampballantyne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14937080725788649588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "td-amp-ballantyne",
      "poi_latitude": "35.0593419",
      "poi_longitude": "-80.8473887",
      "poi_miles_from_property": "22.4 mi",
      "poi_walking_minutes": "8 hours 18 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 704-248-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70J1hOadVogRdGj3sccrS88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_eabe8de02e02ebca418097a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "The Bowl at Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "15119 Bowl St, Charlotte, NC 28277, USA",
      "poi_short_description": "Destination offering a variety of eateries, a park, a stream, and shops, as well as events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1cba-755b-bbfe-2dee47c988b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1cba-755b-bbfe-2dee47c988b2",
        "storage_key": "property/5706772312489984/019f14fa-1cba-755b-bbfe-2dee47c988b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thebowlnc.com/?utm_source=2060digital&utm_medium=localseo&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13769928705673943822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bowl-at-ballantyne",
      "poi_latitude": "35.0578745",
      "poi_longitude": "-80.845811",
      "poi_miles_from_property": "22.5 mi",
      "poi_walking_minutes": "8 hours 21 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-222d-71fc-af0d-0f53ef863149",
        "storage_key": "property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVY1gNvCdVogRDlsmnDOdGL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_1e6e72116d568c756d0445d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "The Olde Mecklenburg Restaurant & Biergarten at Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "15025 Bowl St, Charlotte, NC 28277, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0727-73b9-a7e1-31001d15a094.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0727-73b9-a7e1-31001d15a094",
        "storage_key": "property/5706772312489984/019f14fa-0727-73b9-a7e1-31001d15a094.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ombbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5238904532443810007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olde-mecklenburg-restaurant--biergarten-at-ballantyne",
      "poi_latitude": "35.0566421",
      "poi_longitude": "-80.84553489999999",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 23 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 984-253-1980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b1a-742b-a1c1-8a35e2ef74e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b1a-742b-a1c1-8a35e2ef74e6",
        "storage_key": "property/5706772312489984/019f14fa-4b1a-742b-a1c1-8a35e2ef74e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTT5Io16dVogR10h_VOpTtEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "beer_garden"
    },
    {
      "id": "ec_034905480f173be0c7b41e1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "AMC Carolina Pavilion 22",
      "poi_type": "Entertainment",
      "poi_address": "9541 South Blvd, Charlotte, NC 28273, USA",
      "poi_short_description": "Multiplex offering reclining armchairs, on-screen ads and stadium seating, as well as snacks and a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1d60-761b-ba38-e7a37a8a21e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1d60-761b-ba38-e7a37a8a21e7",
        "storage_key": "property/5706772312489984/019f14fa-1d60-761b-ba38-e7a37a8a21e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-carolina-pavilion-22?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13797956241145416126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-carolina-pavilion-22",
      "poi_latitude": "35.10838330000001",
      "poi_longitude": "-80.8745206",
      "poi_miles_from_property": "19.8 mi",
      "poi_walking_minutes": "7 hours 24 mins",
      "poi_biking_minutes": "1 hour 57 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 704-643-1507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b20-77f9-87eb-e7714f600f17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b20-77f9-87eb-e7714f600f17",
        "storage_key": "property/5706772312489984/019f14fa-4b20-77f9-87eb-e7714f600f17.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJVx1c42ucVogRvknbuxgwfL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_0822faf232fb517485d80bd5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Regal Stonecrest at Piper Glen",
      "poi_type": "Entertainment",
      "poi_address": "7824 Rea Rd, Charlotte, NC 28277, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-1f02-72cb-a6bc-5fc147056ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-1f02-72cb-a6bc-5fc147056ffb",
        "storage_key": "property/5706772312489984/019f14fa-1f02-72cb-a6bc-5fc147056ffb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-stonecrest-piper-glen-0384?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12763181794764316193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-stonecrest-at-piper-glen",
      "poi_latitude": "35.06248000000001",
      "poi_longitude": "-80.81882999999999",
      "poi_miles_from_property": "21.9 mi",
      "poi_walking_minutes": "8 hours 7 mins",
      "poi_biking_minutes": "2 hours 11 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b20-77f9-87eb-e7714f600f17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b20-77f9-87eb-e7714f600f17",
        "storage_key": "property/5706772312489984/019f14fa-4b20-77f9-87eb-e7714f600f17.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUOsr12dVogRId6oWDjuH7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_1f71ab681940bb05e2aba90f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Ayrsley Grand Cinema",
      "poi_type": "Entertainment",
      "poi_address": "9110 Kings Parade Blvd, Charlotte, NC 28273, USA",
      "poi_short_description": "New releases from Hollywood in an independent movie theater, with a school program & venue rentals.",
      "poi_long_description": "New releases from Hollywood in an independent movie theater, with a school program & venue rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-23b9-723b-92fb-c525a7a2c618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-23b9-723b-92fb-c525a7a2c618",
        "storage_key": "property/5706772312489984/019f14fa-23b9-723b-92fb-c525a7a2c618.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ayrsleycinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2246405643920285797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ayrsley-grand-cinema",
      "poi_latitude": "35.1391667",
      "poi_longitude": "-80.9322222",
      "poi_miles_from_property": "18.9 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 980-297-7540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b20-77f9-87eb-e7714f600f17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b20-77f9-87eb-e7714f600f17",
        "storage_key": "property/5706772312489984/019f14fa-4b20-77f9-87eb-e7714f600f17.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40REUH2ZVogRZSBN-wfWLB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_fecb07e3c5d0195204c195ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "U.S. National Whitewater Center",
      "poi_type": "Entertainment",
      "poi_address": "5000 Whitewater Center Pkwy, Charlotte, NC 28214, USA",
      "poi_short_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_long_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-2537-75fc-a9b1-4e76007642dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-2537-75fc-a9b1-4e76007642dc",
        "storage_key": "property/5706772312489984/019f14fa-2537-75fc-a9b1-4e76007642dc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.whitewater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500212967885119010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-national-whitewater-center",
      "poi_latitude": "35.2712966",
      "poi_longitude": "-81.00554029999999",
      "poi_miles_from_property": "19.4 mi",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-391-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2661-70bc-a86c-be991176dfde",
        "storage_key": "property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvd734yC9VogRIh4ieMP2mJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_88b44665ad02f2ddcca5cf6f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-240a-7379-b548-524688396404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-240a-7379-b548-524688396404",
        "storage_key": "property/5706772312489984/019f14fa-240a-7379-b548-524688396404.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 26 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_436d7ebdbe3c31eedf6fe4b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Carolina Raptor Center",
      "poi_type": "Entertainment",
      "poi_address": "6000 Sample Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "Educational center featuring outdoor trails with live raptors, flight shows & indoor exhibits.",
      "poi_long_description": "Educational center featuring outdoor trails with live raptors, flight shows & indoor exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-27a2-779a-b39c-7815ee793bbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-27a2-779a-b39c-7815ee793bbf",
        "storage_key": "property/5706772312489984/019f14fa-27a2-779a-b39c-7815ee793bbf.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.carolinaraptorcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=737024395228417001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolina-raptor-center",
      "poi_latitude": "35.3503722",
      "poi_longitude": "-80.9183836",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 704-875-6521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7eHVxDWkVogR6QtjVMhvOgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_745d50c8ffb91138568718cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Bechtler Museum of Modern Art",
      "poi_type": "Entertainment",
      "poi_address": "420 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Mid-20th-century modern art displayed in an elegant 4-story building filled with natural light.",
      "poi_long_description": "Mid-20th-century modern art displayed in an elegant 4-story building filled with natural light.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-23ac-732e-a42e-16b8da752103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-23ac-732e-a42e-16b8da752103",
        "storage_key": "property/5706772312489984/019f14fa-23ac-732e-a42e-16b8da752103.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://bechtler.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4402061911705097934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bechtler-museum-of-modern-art",
      "poi_latitude": "35.2244822",
      "poi_longitude": "-80.8473279",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 704-353-9209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b2d-75a7-b250-40a568a11804.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b2d-75a7-b250-40a568a11804",
        "storage_key": "property/5706772312489984/019f14fa-4b2d-75a7-b250-40a568a11804.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSzQNSmgVogRzpZ1TvxDFz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_6cf957ad005d33bfb8aed0ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Atrium Health University City",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-4443-72ed-82b1-831bdae2ea10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-4443-72ed-82b1-831bdae2ea10",
        "storage_key": "property/5706772312489984/019f14f6-4443-72ed-82b1-831bdae2ea10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-265e-710b-9c63-c4dac6ccc636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-265e-710b-9c63-c4dac6ccc636",
        "storage_key": "property/5706772312489984/019d02f2-265e-710b-9c63-c4dac6ccc636.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_6a9ad25585a13ec4bb6d2d97",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9325 JW Clay Blvd Ste 221, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-2ca6-7346-a599-6a5b2d190c74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-2ca6-7346-a599-6a5b2d190c74",
        "storage_key": "property/5706772312489984/019f14fa-2ca6-7346-a599-6a5b2d190c74.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=5661548961259477027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.3107795",
      "poi_longitude": "-80.7457122",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-863-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUFVFxgdVIgRI1hausjckU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_033e29280b48dac3f6e9c214",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "FastMed Urgent Care Charlotte Mallard Creek",
      "poi_type": "Health and Wellness",
      "poi_address": "2728 W Mallard Creek Church Rd Ste 300, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-28ae-71b9-a25e-963759a91c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-28ae-71b9-a25e-963759a91c1f",
        "storage_key": "property/5706772312489984/019f14fa-28ae-71b9-a25e-963759a91c1f.webp",
        "width": 904,
        "height": 609
      },
      "poi_business_url": "https://www.fastmed.com/urgent-care-centers/charlotte-nc-walk-in-clinic-west-mallard-creek-church-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=12204928611885799257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fastmed-urgent-care-charlotte-mallard-creek",
      "poi_latitude": "35.3417425",
      "poi_longitude": "-80.7655249",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-218-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhe1vMVUcVIgRWVd0dOidYKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_583a091201e539f133c42ce3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7735 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-27eb-70ee-8ca6-375173c5cc27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-27eb-70ee-8ca6-375173c5cc27",
        "storage_key": "property/5706772312489984/019f14fa-27eb-70ee-8ca6-375173c5cc27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/2134-charlotte-nc/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14454123513738397752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.29542",
      "poi_longitude": "-80.75815820000001",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-547-0972",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b1a-742b-a1c1-8cc092e9c025.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b1a-742b-a1c1-8cc092e9c025",
        "storage_key": "property/5706772312489984/019f14fa-4b1a-742b-a1c1-8cc092e9c025.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wzzDDAcVIgROIj_J8Fcl8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9b702d426aaf661963546fd1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8538 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-2d00-7159-96a0-3dde6037dc5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-2d00-7159-96a0-3dde6037dc5c",
        "storage_key": "property/5706772312489984/019f14fa-2d00-7159-96a0-3dde6037dc5c.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8538+n+tryon+st-charlotte-nc-28262/id=4547",
      "poi_directions_map_url": "https://maps.google.com/?cid=9712234873269453930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.30457740000001",
      "poi_longitude": "-80.7496324",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-547-8551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7dKASQcVIgRagRj3CjKyIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_194936f0e84eff5cd09f5a42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10515 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-0c38-737d-8a02-563f11512971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-0c38-737d-8a02-563f11512971",
        "storage_key": "property/5706772312489984/019f14fa-0c38-737d-8a02-563f11512971.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/10515-mallard-creek-road-charlotte-nc-28262/storeid=2559?WT.mc_id=LS_GOOGLE_RX_2559",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047423090634507296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3424104",
      "poi_longitude": "-80.7676571",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-547-9739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4b1a-742b-a1c1-8cc092e9c025.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fa-4b1a-742b-a1c1-8cc092e9c025",
        "storage_key": "property/5706772312489984/019f14fa-4b1a-742b-a1c1-8cc092e9c025.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_Q8k6odVIgRIMQbkHgLMac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_de006da85a416141d5580896",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10215 University City Blvd B, Charlotte, NC 28213, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning beds, and 24-hour access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-294b-779d-8a13-0ccca6121d32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-294b-779d-8a13-0ccca6121d32",
        "storage_key": "property/5706772312489984/019f14f6-294b-779d-8a13-0ccca6121d32.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/charlotte-university-blvd-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15550441792175585086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.31210069999999",
      "poi_longitude": "-80.713909",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-548-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYakZvEbVIgRPrcDk2tEztc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_065f5722c54d539a67f3b9de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "8709 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Chain gym featuring cardio and strength equipment, basketball courts, and a Kids' Club.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f1-e608-7189-a12b-b6acce86f3bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-e608-7189-a12b-b6acce86f3bb",
        "storage_key": "property/5706772312489984/019d02f1-e608-7189-a12b-b6acce86f3bb.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/university/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15703214807914536897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "35.3113238",
      "poi_longitude": "-80.7552175",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-405-1330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRQH-yYcVIgRwV9mKasG7dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_850719791e1820c9e05f680c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3016 Prosperity Church Rd B, Charlotte, NC 28269, USA",
      "poi_short_description": "Group studio workout chain offering cardio and strength training led by coaches and trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-2fbb-714b-9fe5-9c933510c84e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-2fbb-714b-9fe5-9c933510c84e",
        "storage_key": "property/5706772312489984/019f14fa-2fbb-714b-9fe5-9c933510c84e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/charlotte-north-carolina-0506?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=15834564676310859770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.34303999999999",
      "poi_longitude": "-80.76845",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-705-2377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJezBpiKodVIgR-v90kK2sv9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0369382612ee7b8de24ee4c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Keith Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8100 Old Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Offering programs and services for all ages and abilities, this youth center has a pool, and gym.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-2c18-738d-8125-b68e76b90532.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-2c18-738d-8125-b68e76b90532",
        "storage_key": "property/5706772312489984/019f14f6-2c18-738d-8125-b68e76b90532.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ymcacharlotte.org/locations/keith-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=9660733629701512364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keith-family-ymca",
      "poi_latitude": "35.3160647",
      "poi_longitude": "-80.77850409999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-716-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_l4NMQdVIgRrFwHLA3SEYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7a0ced1a63347bb994da78cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-551e-7721-9029-4b3c0ab46888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-551e-7721-9029-4b3c0ab46888",
        "storage_key": "property/5706772312489984/019f14f6-551e-7721-9029-4b3c0ab46888.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_db1910918ef5a7f234d656e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Mallard Creek Greenway - East Terminus",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3086-75ca-b252-f996ed729609.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3086-75ca-b252-f996ed729609",
        "storage_key": "property/5706772312489984/019f14fa-3086-75ca-b252-f996ed729609.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Greenways/OpenGreenways/Pages/MallardCreekandClark'sCreek.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15209037215157520469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-greenway---east-terminus",
      "poi_latitude": "35.32064940000001",
      "poi_longitude": "-80.73165089999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaiP2cwdVIgRVQgpKcRaEdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_c268cbd9528a91c0fc6e2b79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Clarks Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9729 Mallard Creek Rd, Charlotte, NC 28267, USA",
      "poi_short_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_long_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3339-74eb-80cd-d1a47b5fd800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3339-74eb-80cd-d1a47b5fd800",
        "storage_key": "property/5706772312489984/019f14fa-3339-74eb-80cd-d1a47b5fd800.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285017145315421591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-greenway",
      "poi_latitude": "35.3345362",
      "poi_longitude": "-80.7740029",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWo_U0gcVIgRl-3jjGiTPsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_a122b0c74392cbaf2eba8945",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Toby Creek Greenway - Ruth G. Shaw Trailhead (2 miles)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8541 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-31b4-7545-8c1d-f3c6755ee826.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-31b4-7545-8c1d-f3c6755ee826",
        "storage_key": "property/5706772312489984/019f14fa-31b4-7545-8c1d-f3c6755ee826.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carolinathreadtrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13519428957779332624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toby-creek-greenway---ruth-g-shaw-trailhead-2-miles",
      "poi_latitude": "35.2968741",
      "poi_longitude": "-80.7414333",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-376-2556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73PsZ6AeVIgREA6REgKpnrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_c243ea7deed34ec52e290bc3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Mallard Creek Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2530 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation center with a gym, multipurpose rooms, and a nature trail, plus parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-33a7-7085-8c24-1b9def134545.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-33a7-7085-8c24-1b9def134545",
        "storage_key": "property/5706772312489984/019f14fa-33a7-7085-8c24-1b9def134545.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/places-to-visit/rec-centers/mallard-creek-recreation-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=944166955806814435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-recreation-center",
      "poi_latitude": "35.3570067",
      "poi_longitude": "-80.759945",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-314-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcZ6fOQcVIgR4_CGCdhaGg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_7e835266b1d4d7c3779e82c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "University Center Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8025 Pike Road, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-2f6c-732f-8b37-51931df1129d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-2f6c-732f-8b37-51931df1129d",
        "storage_key": "property/5706772312489984/019f14fa-2f6c-732f-8b37-51931df1129d.webp",
        "width": 1026,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5503540540632259783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-center-dog-park",
      "poi_latitude": "35.3069077",
      "poi_longitude": "-80.7593108",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2661-70bc-a86c-be991176dfde",
        "storage_key": "property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdS8VGYdVIgRx9xYc_aAYEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_eeb122523a5b6ba21f65af0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Mallard Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3001 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation area featuring 8 soccer fields, a batting cage, and 2 playgrounds, plus a volleyball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3743-736d-87a1-bdc6aaae8147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3743-736d-87a1-bdc6aaae8147",
        "storage_key": "property/5706772312489984/019f14fa-3743-736d-87a1-bdc6aaae8147.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=412983690555762575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park",
      "poi_latitude": "35.3614698",
      "poi_longitude": "-80.7624001",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2661-70bc-a86c-be991176dfde",
        "storage_key": "property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6J0seEcVIgRjyebfXo2uwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_990a85496054836d849ff0ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Paradise Valley Par 3",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "110 Barton Creek Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Mini-golf complex offering 18-hole course (9 indoors and 9 outdoors), plus a par-3 course.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-334c-7318-b5aa-4bd38593a150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-334c-7318-b5aa-4bd38593a150",
        "storage_key": "property/5706772312489984/019f14fa-334c-7318-b5aa-4bd38593a150.webp",
        "width": 1170,
        "height": 875
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5680802421410763951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paradise-valley-par-3",
      "poi_latitude": "35.3159827",
      "poi_longitude": "-80.7405314",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-548-1808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2867-700f-b344-bb0cf89786ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2867-700f-b344-bb0cf89786ba",
        "storage_key": "property/5706772312489984/019d02f2-2867-700f-b344-bb0cf89786ba.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwiFSRQcVIgRrxReP7RD1k4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_95f7c82bcbc4b627066cccf9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Barton Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9201 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3c3a-7399-b601-c02b974ad2d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3c3a-7399-b601-c02b974ad2d4",
        "storage_key": "property/5706772312489984/019f14fa-3c3a-7399-b601-c02b974ad2d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3238980340491376752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barton-creek-greenway",
      "poi_latitude": "35.3147855",
      "poi_longitude": "-80.74741709999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4jr-HEdVIgRcFh2dXUr8yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_3976d572bd7143cfd4939383",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Clarks Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5435 Hucks Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Family-friendly park equipped with picnic tables, swing sets, playgrounds, basketball courts, splash pads and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3a55-7649-badc-e3aa6c629f85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3a55-7649-badc-e3aa6c629f85",
        "storage_key": "property/5706772312489984/019f14fa-3a55-7649-badc-e3aa6c629f85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16436839230062349110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-park",
      "poi_latitude": "35.3541742",
      "poi_longitude": "-80.808039",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2661-70bc-a86c-be991176dfde",
        "storage_key": "property/5706772312489984/019d02f2-2661-70bc-a86c-be991176dfde.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6y6TghinVogRNksSkjFiG-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_71d25360f5f597e47a9fa647",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Mallard Creek Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2158274625695479655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park--ride",
      "poi_latitude": "35.32323",
      "poi_longitude": "-80.77292",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcW0-QLYdVIgRZ3dRSFa78x0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_7ff620713e29684694c25ca1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "J W Clay Boulevard Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "9201-9203 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3bd8-7508-b1e2-14c6c2eae337.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3bd8-7508-b1e2-14c6c2eae337",
        "storage_key": "property/5706772312489984/019f14fa-3bd8-7508-b1e2-14c6c2eae337.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottenc.gov/CATS/Rail/LYNX-Stations-and-Park-and-Rides/JW-Clay-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=16144626486294448140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-w-clay-boulevard-station",
      "poi_latitude": "35.310852",
      "poi_longitude": "-80.74562829999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUtrPT0cVIgRDIjxWkA8DeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_5b8560f06f0023a75716713b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "University City Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "7205 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-5ed9-74cb-9436-79a1e052dcfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-5ed9-74cb-9436-79a1e052dcfd",
        "storage_key": "property/5706772312489984/019f14f6-5ed9-74cb-9436-79a1e052dcfd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlonbvcsattenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12467337922677263454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-city-blvd",
      "poi_latitude": "35.2869215",
      "poi_longitude": "-80.76073650000001",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz4QjIUeVIgRXkzvL8nhBK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_e651642df68a7fc11699dcf3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Northlake Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574504833305702147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall-park--ride",
      "poi_latitude": "35.352833",
      "poi_longitude": "-80.85521899999999",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfdxJlWmVogRA286UNLmoKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_aa6d6c721d46e5cfbad6bb60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Riverbend Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8842128954005509861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbend-park-and-ride",
      "poi_latitude": "35.32882",
      "poi_longitude": "-80.94192",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKf5NEWKkVogR5daxoW-NtXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_d64e4afef6e67d1fec91c9af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Trade St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4144275419840309105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2246882",
      "poi_longitude": "-80.8406333",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN63efwChVogRcef2eolsgzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_7c1b47cc62475af4dc9aa1f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Amtrak Charlotte Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1914 N Tryon St, Charlotte, NC 28206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3dda-77d9-abb9-cfb8a67b08df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3dda-77d9-abb9-cfb8a67b08df",
        "storage_key": "property/5706772312489984/019f14fa-3dda-77d9-abb9-cfb8a67b08df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amtrak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17371830586323027624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-charlotte-station",
      "poi_latitude": "35.2412903",
      "poi_longitude": "-80.8226901",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 866-227-0296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZ3bklOhVogRqMYM3OAjFfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_a08220294fed798ab0d928aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4025-760b-8d36-8dda7f30f777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-4025-760b-8d36-8dda7f30f777",
        "storage_key": "property/5706772312489984/019f14fa-4025-760b-8d36-8dda7f30f777.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "19.4 mi",
      "poi_walking_minutes": "7 hours 11 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-29a7-74f9-b5f5-f2bc5fb47f18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-29a7-74f9-b5f5-f2bc5fb47f18",
        "storage_key": "property/5706772312489984/019d02f2-29a7-74f9-b5f5-f2bc5fb47f18.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_5d771bd82bd1d8b5b784ac2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-15da-7728-815a-290870be6cb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-15da-7728-815a-290870be6cb3",
        "storage_key": "property/5706772312489984/019f14f6-15da-7728-815a-290870be6cb3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-21c5-76a4-b1a9-f15409b2104b",
        "storage_key": "property/5706772312489984/019d02f2-21c5-76a4-b1a9-f15409b2104b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_8ba5d3b6a2ed5880019507a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Atrium Health University City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-4443-72ed-82b1-831bdae2ea10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-4443-72ed-82b1-831bdae2ea10",
        "storage_key": "property/5706772312489984/019f14f6-4443-72ed-82b1-831bdae2ea10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-265e-710b-9c63-c4dac6ccc636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-265e-710b-9c63-c4dac6ccc636",
        "storage_key": "property/5706772312489984/019d02f2-265e-710b-9c63-c4dac6ccc636.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_5f77971a768fa970f1e06506",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Enterprise Fleet Management",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8335 IBM Dr Ste 100, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-3ddc-7443-9700-52134d49d412.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-3ddc-7443-9700-52134d49d412",
        "storage_key": "property/5706772312489984/019f14fa-3ddc-7443-9700-52134d49d412.webp",
        "width": 1280,
        "height": 320
      },
      "poi_business_url": "https://www.efleets.com/en/locations/charlotte.html?mcid=yext:24885836",
      "poi_directions_map_url": "https://maps.google.com/?cid=9976593112716616553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enterprise-fleet-management",
      "poi_latitude": "35.307694",
      "poi_longitude": "-80.7671396",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-944-4493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeulItMdVIgRaSMV6JP6c4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_b6f1051a19198ef99ed4963b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Equitable",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7207 IBM Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4033-73a2-88a7-30460d2bdb1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-4033-73a2-88a7-30460d2bdb1c",
        "storage_key": "property/5706772312489984/019f14fa-4033-73a2-88a7-30460d2bdb1c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://equitable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17458692327068683216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "equitable",
      "poi_latitude": "35.3077013",
      "poi_longitude": "-80.7712655",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 866-444-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQpZzNMdVIgR0EvE3Su8SfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_e486aea25a847147d1572fc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "IKEA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8300 Ikea Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14f6-0ba0-71bb-9c60-cedbdbc817e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f6-0ba0-71bb-9c60-cedbdbc817e5",
        "storage_key": "property/5706772312489984/019f14f6-0ba0-71bb-9c60-cedbdbc817e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/charlotte/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=charlotte",
      "poi_directions_map_url": "https://maps.google.com/?cid=8666071200226601882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "35.2935168",
      "poi_longitude": "-80.7647415",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-222d-71fc-af0d-0f53ef863149",
        "storage_key": "property/5706772312489984/019d02f2-222d-71fc-af0d-0f53ef863149.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNUGiFYceVIgRmuu_f9cRRHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_427240d064fa0d61233d810d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "Wells Fargo",
      "poi_type": "Major Employers & Offices",
      "poi_address": "CIC BLDG 3, 1525 W W.T.Harris Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Private campus featuring a full fitness center, a bank and a mile-long nature trail.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-428c-7389-86a3-2c0d175999a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-428c-7389-86a3-2c0d175999a5",
        "storage_key": "property/5706772312489984/019f14fa-428c-7389-86a3-2c0d175999a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wellsfargo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7301539158896786941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wells-fargo",
      "poi_latitude": "35.31183559999999",
      "poi_longitude": "-80.77074809999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-869-3557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09nIF84dVIgR_b2lBy5HVGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_39801374cb07134fa389d6ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "generator",
      "poi_name": "IBM",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10925 David Taylor Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14fa-4020-760f-9f4c-f643964a0410.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-4020-760f-9f4c-f643964a0410",
        "storage_key": "property/5706772312489984/019f14fa-4020-760f-9f4c-f643964a0410.webp",
        "width": 1200,
        "height": 720
      },
      "poi_business_url": "http://www.ibm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18312348945756321416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ibm",
      "poi_latitude": "35.3397408",
      "poi_longitude": "-80.76665109999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-426-4968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-2515-764b-b435-e4aaf6a3a999",
        "storage_key": "property/5706772312489984/019d02f2-2515-764b-b435-e4aaf6a3a999.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJga6ZeVIcVIgRiPbN2leIIv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8636424dea3dae32182a179c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_596122803226af309b3c8f26",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_77305f2cc5c060c8b5545d2d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cb93b645a9648fabe59d3931",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fb465d551027b7d51f61b170",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a9d9b9d3361e0e06104ce979",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_63647b6978964208c55f485d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "rating": "5",
      "name": "David Carter",
      "text": "The apartments are nice, but as a tenant, what really stands out to me is the service from the people here. Today, we had an amazing repair specialist by the name of Juan who came to take care of a few small things in our apartment, and you can tell he is a master at his craft. He was very pleasant and knowledgeable, and he fixed our minor issues with ease. Community support from people like him and others is the reason we’ll continue to stay here. Great job all around.",
      "date": "2026-02-26",
      "title": "false"
    },
    {
      "id": "ec_bc2a976f7edd1eedddebdc81",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "rating": "5",
      "name": "Cynthia Williams",
      "text": "Modesto, does a very good job. He comes and get the job done. And he's a very nice person too. I don't mind him coming in and doing work in my home.",
      "date": "2026-06-01",
      "title": "false"
    },
    {
      "id": "ec_eadc546d25109ea1a492b685",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "rating": "5",
      "name": "Kiwi P",
      "text": "Juan and Modesto are a great help. They always do a great job on maintenance in my apartment and they helped bring a huge package into my apartment when I couldn’t lift it because I’m currently pregnant. I love the community overall. The staff is nice and maintenance team are great and professional. Love The Bellamy.",
      "date": "2026-02-26",
      "title": "false"
    },
    {
      "id": "ec_fbe6e0c67e646e8cd62dec30",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "rating": "4",
      "name": "jacqueline rebeiro",
      "text": "Nice location , friendly neighbors and friendly staff.   Want to give a big thank you to Maintenance staff member -Modesto.  He was very professional and thorough in the completion of service requests I submitted for my unit.  He also made sure the job was completed to my satisfaction.  Thank you Modesto!",
      "date": "2026-03-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_43039794-b849-4a13-8f91-ef2ef3c82ac1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-71a9-727d-a059-20ba37fbc22d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room featuring a brown leather sofa, coffee table, and a TV mounted on the wall.",
        "public_id": "019d02f2-71a9-727d-a059-20ba37fbc22d",
        "storage_key": "property/5706772312489984/019d02f2-71a9-727d-a059-20ba37fbc22d.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA - 1,250 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zKnNNMmwQPB"
    },
    {
      "id": "custom_8442e1a4-fa76-4ed3-8605-6eb237f4a331",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Modern 1-bed, 1.5-bath apartment with 1014 sq. ft. of living space. Features open-concept layout, updated kitchen, located in Charlotte, NC.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-79e8-748e-bc0b-0397bc236207.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with ceiling fan and large windows",
        "public_id": "019d02f2-79e8-748e-bc0b-0397bc236207",
        "storage_key": "property/5706772312489984/019d02f2-79e8-748e-bc0b-0397bc236207.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "A1 | 1 Bedroom & 1.5 Bathrooms - 1014 square feet",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Yj1gA6cPJbf"
    },
    {
      "id": "custom_14ab9c1a-01be-4459-86dc-344394ce9b71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Modern 2-bedroom, 2-bathroom apartment with 1250 sq. ft. of living space. Features updated kitchen, carpeted bedrooms, and neutral decor throughout. Located in Charlotte, NC.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019d02f2-77bd-76aa-956b-b3f08a8dc9a0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
        "public_id": "019d02f2-77bd-76aa-956b-b3f08a8dc9a0",
        "storage_key": "property/5706772312489984/019d02f2-77bd-76aa-956b-b3f08a8dc9a0.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "B1 | 2 Bedroom & 2 Bathroom - 1250 square feet",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HFLVcDqD5Hh"
    },
    {
      "id": "custom_2e602721-ae06-4e72-b860-d4a52ecda90c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f14c3-58c1-778d-ab13-fc562e11e7ee.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-58c1-778d-ab13-fc562e11e7ee",
        "storage_key": "property/5706772312489984/019f14c3-58c1-778d-ab13-fc562e11e7ee.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Bellamy Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/thJommOQxBY"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-0efe-76dd-8257-9553842fef3d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-bellamy",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984"
    },
    {
      "lead_collector_id": "0198aa46-0f5f-755e-a78a-99bf9e72debb",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-bellamy",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984"
    },
    {
      "lead_collector_id": "0198aa46-0fc3-73d8-8992-2cc4d455965c",
      "lead_source": "LANDING_PAGE",
      "name": "the-bellamy",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-university-city-north-554",
      "search_query": "in unit laundry apartments in University City North",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments in University City North",
      "h2_subtitle": "Discover premier in unit laundry apartments in University City North at The Bellamy. Enjoy modern conveniences and luxurious living in Charlotte, NC.",
      "page_copy": "Searching for in unit laundry apartments in University City North? Look no further than The Bellamy, located in vibrant Charlotte, NC. Our spacious floor plans range from cozy one-bedroom to expansive three-bedroom units, each equipped with modern washer/dryer facilities. This means you can enjoy the luxury of doing laundry in the comfort of your own home without any hassle.\n\nResidents at The Bellamy benefit from more than just in-unit laundry. With a sparkling pool, pet play area, and fitness center, our community offers amenities that complement an elevated lifestyle. Discover stylish interiors, modern conveniences, and a welcoming community atmosphere nestled in the heart of University City North. Experience the perfect blend of comfort and convenience today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apartments - University City North",
      "seo_description": "Explore in unit laundry apartments in University City North at The Bellamy, offering spacious floor plans and luxury amenities for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "air-conditioned-luxury-apartments-charlotte-nc-741",
      "search_query": "air conditioned luxury apartments Charlotte NC",
      "category": "Amenity",
      "h1_title": "Air Conditioned Luxury Apartments in Charlotte, NC",
      "h2_subtitle": "Experience unparalleled comfort in our air conditioned luxury apartments in Charlotte, NC. The Bellamy offers modern amenities and stylish living spaces.",
      "page_copy": "Are you seeking air conditioned luxury apartments in Charlotte, NC? The Bellamy is the perfect destination for those looking for comfort and style. Nestled in the heart of Charlotte's vibrant University City North, our apartments offer a refreshing escape with air-conditioned interiors providing a cool and inviting atmosphere throughout each spacious unit.\n\nAt The Bellamy, luxury living extends beyond air conditioning. Enjoy access to premium amenities such as a sparkling pool, modern fitness center, and tennis court, all designed to enhance your lifestyle. With stylish interiors and excellent online services, you'll find everything you need to live comfortably in one place. Come explore our luxurious homes and discover the perfect balance of elegance and convenience at The Bellamy today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Luxury Apartments - Charlotte, NC",
      "seo_description": "Enjoy air conditioned luxury apartments in Charlotte, NC at The Bellamy. Discover spacious interiors and premium amenities in University City North.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-mecklenburg-county-164",
      "search_query": "pet friendly apartments with dog park Mecklenburg County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Park in Mecklenburg",
      "h2_subtitle": "The Bellamy offers pet friendly apartments with a dog park in Mecklenburg County. Experience luxury living tailored to you and your furry friends.",
      "page_copy": "Looking for pet friendly apartments with a dog park in Mecklenburg County? The Bellamy in Charlotte, NC, is the ideal choice for pet owners seeking a home that welcomes their four-legged companions. Our community not only offers spacious floor plans but also features a dedicated pet play area where your pets can roam and play freely.\n\nLocated in the lively University City North neighborhood, The Bellamy is more than just a pet lover's haven. Enjoy luxurious amenities such as air-conditioned interiors, a sparkling pool, and a modern fitness center. With convenient online services and attentive concierge care, both you and your furry friends will feel right at home. Come and explore our pet-friendly community designed to cater to all your needs at The Bellamy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Park - Mecklenburg",
      "seo_description": "Discover pet friendly apartments with a dog park at The Bellamy in Mecklenburg County. Luxury living for you and your pets in Charlotte, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "apartments-with-pool-university-city-north-669",
      "search_query": "apartments with pool near University City North",
      "category": "Amenity",
      "h1_title": "Apartments with Pool Near University City North",
      "h2_subtitle": "The Bellamy offers apartments with a pool near University City North. Enjoy luxurious amenities in the vibrant city of Charlotte, NC.",
      "page_copy": "Searching for apartments with a pool near University City North? The Bellamy, located in the heart of Charlotte, NC, offers ideal living with a sparkling pool perfect for relaxation and recreation. Immerse yourself in a community where refreshing swims are just steps away from your apartment.\n\nBeyond the pool, The Bellamy provides an array of luxurious amenities designed for modern living. Residents enjoy access to a fitness center, tennis court, and stylish, air-conditioned interiors. Our convenient location in University City North ensures you're close to the city's vibrant offerings while enjoying a retreat-like atmosphere. Discover the perfect blend of leisure and luxury at The Bellamy today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool - University City North",
      "seo_description": "Find apartments with a pool near University City North at The Bellamy. Enjoy luxury amenities and vibrant Charlotte living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-charlotte-28262-415",
      "search_query": "dishwasher equipped apartments in Charlotte 28262",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in Charlotte 28262",
      "h2_subtitle": "Explore dishwasher equipped apartments in Charlotte 28262 at The Bellamy. Enjoy modern convenience and vibrant community living.",
      "page_copy": "If you're in search of dishwasher equipped apartments in Charlotte 28262, look no further than The Bellamy. Nestled in the thriving University City North neighborhood, our community combines style and convenience with modern interiors featuring necessary amenities like dishwashers in each unit, making daily chores a breeze.\n\nAt The Bellamy, life extends beyond the kitchen. Enjoy a vibrant community atmosphere with luxurious features such as a sparkling pool, state-of-the-art fitness center, and a concierge ready to assist with your needs. Our Charlotte location offers the best of both worlds—easy access to urban excitement and peaceful retreat-like living. Experience the comfort and efficiency of The Bellamy and find your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments - Charlotte 28262",
      "seo_description": "Discover dishwasher equipped apartments in Charlotte 28262 at The Bellamy. Enjoy luxury features and vibrant living in University City North.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-university-city-north-412",
      "search_query": "1 bedroom apartments university city north",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in University City North",
      "h2_subtitle": "Find 1 bedroom apartments in University City North at The Bellamy. Discover spacious living in a vibrant Charlotte community.",
      "page_copy": "Are you looking for 1 bedroom apartments in University City North? The Bellamy in Charlotte, NC offers the perfect blend of comfort and style tailored for your lifestyle. Our well-designed one-bedroom layouts provide ample living space, modern interiors, and a range of community amenities that enhance your living experience.\n\nSituated in the lively University City North neighborhood, The Bellamy places you in the heart of Charlotte's vibrant culture while offering the tranquility of a residential retreat. Enjoy access to luxurious amenities like a sparkling pool, state-of-the-art fitness center, and more. With the convenience of a central location and upscale features, The Bellamy makes it easy to call Charlotte home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments - University City North",
      "seo_description": "Discover 1 bedroom apartments in University City North at The Bellamy. Enjoy spacious living and vibrant Charlotte amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-near-28262-569",
      "search_query": "2 bedroom apartments near 28262",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 28262",
      "h2_subtitle": "Discover spacious 2 bedroom apartments near 28262 at The Bellamy. Enjoy modern living and ample amenities in Charlotte.",
      "page_copy": "Searching for 2 bedroom apartments near 28262? Look no further than The Bellamy, where comfort and convenience meet in the vibrant city of Charlotte, NC. Our thoughtfully designed two-bedroom layouts provide ample space and modern features that cater to your lifestyle needs. Enjoy the tranquil surroundings of University City North as you settle into your new home.\n\nThe Bellamy offers more than just a place to live. With luxurious amenities such as a sparkling pool, fitness center, and pet play area, our community is designed to enhance your residential experience. Located in the heart of Charlotte's 28262 area, you have easy access to city attractions while enjoying a peaceful retreat from the hustle and bustle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments - Near 28262",
      "seo_description": "Find spacious 2 bedroom apartments near 28262 at The Bellamy. Enjoy modern living and luxurious amenities in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5706772312489984",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-mecklenburg-county-794",
      "search_query": "3 bedroom apartments mecklenburg county",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Mecklenburg County",
      "h2_subtitle": "Explore 3 bedroom apartments in Mecklenburg County at The Bellamy. Luxurious living in Charlotte with room to grow.",
      "page_copy": "For those seeking spacious 3 bedroom apartments in Mecklenburg County, The Bellamy offers an exceptional living experience in the heart of Charlotte, NC. Our generously sized three-bedroom units provide ample space, perfect for families or roommates looking to make the most of their living arrangements. Situated in the bustling University City North neighborhood, you'll enjoy both the vibrancy of city life and the comfort of modern amenities.\n\nAt The Bellamy, residents enjoy access to a variety of luxurious features, including a sparkling pool, state-of-the-art fitness center, and a pet play area. Positioned in Mecklenburg County, our community provides easy access to all Charlotte has to offer, while providing a serene setting to call home. Embrace elevated living in a welcoming environment where convenience and style meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen island with black marble countertop and white cabinets",
        "public_id": "019f6c12-0ff6-7159-85b8-c75157662900",
        "storage_key": "property/5706772312489984/019f6c12-0ff6-7159-85b8-c75157662900.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments - Mecklenburg County",
      "seo_description": "Discover spacious 3 bedroom apartments in Mecklenburg County at The Bellamy. Enjoy luxury and convenience in a vibrant Charlotte community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2600"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "3391651926"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5056163"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5BSWM26"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9835663923"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f478d3d011f130de"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/k9zw431lp87"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/36f4d3ff-48b5-4689-8db8-5dfce001599f"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "980-291-9876"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im9ZY2VoTUJmMjFndlRjNG1UWEk3RlE9PSIsInZhbHVlIjoiZElaV3hnekZNUUxwNURCWGRic2ZJQT09IiwibWFjIjoiYThlZGMwNzhhNTU4OTZmY2IzZGYzYzZiZjFlZGVjYWEyODIwZThiMDJlYThlZDhmZjEyZjFiZTQ3NWJhMmU4OSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2600",
  "custom_repli_id": "3391651926",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5056163",
  "custom_google_gtm_id": "GTM-5BSWM26",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "9835663923",
  "custom_knock_community_id": "f478d3d011f130de",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/k9zw431lp87",
  "custom_self_guided_tour_url": "https://selftournow.com/property/36f4d3ff-48b5-4689-8db8-5dfce001599f",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "980-291-9876",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im9ZY2VoTUJmMjFndlRjNG1UWEk3RlE9PSIsInZhbHVlIjoiZElaV3hnekZNUUxwNURCWGRic2ZJQT09IiwibWFjIjoiYThlZGMwNzhhNTU4OTZmY2IzZGYzYzZiZjFlZGVjYWEyODIwZThiMDJlYThlZDhmZjEyZjFiZTQ3NWJhMmU4OSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "9fecda3c-5492-4743-9714-196cf4cf7603",
  "custom_audioeye_site_hash": "ef117434c765fcf8310ec41e81516c45"
};

export const generatedAt = '2026-11-03T20:31:11.915Z';
